/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Toast_Duplicate_CodeInputs */

const vi_warehouse_position_toast_duplicate_code = /** @type {(inputs: Warehouse_Position_Toast_Duplicate_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vị trí này đã tồn tại`)
};

/**

* @param {Warehouse_Position_Toast_Duplicate_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_toast_duplicate_code = /** @type {((inputs?: Warehouse_Position_Toast_Duplicate_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Toast_Duplicate_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_toast_duplicate_code(inputs)
});